import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ActionsModalComponent } from '../../shared/actions-modal/actions-modal.component';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root'
})
export class OfflineWarningModalService {
  constructor(private modalCtrl: ModalController) {}

  public async showOfflineWarningModal(): Promise<void> {
    try {
      const modal = await this.modalCtrl.create({
        component: ActionsModalComponent,
        breakpoints: [0, 1],
        initialBreakpoint: 1,
        componentProps: {
          data: {
            message:
              'Нет связи. Данное действие можно делать только при наличии связи. Попробуйте немного позже.',
            title: 'Нет связи',
            imageSrc: '../../../assets/images/offline.svg',
            errorTitle: true
          }
        }
      });
      await modal.present();
    } catch (err) {
      Sentry.captureException(err);
    }
  }
}
